module.exports = __webpack_public_path__ + "img/RekionImage.794015c3.svg";